// Calendar sync status pill (Phase 5). Pure presentational: state comes from
// calendarSyncState(doc), onSync retries the write-through. 'na' renders
// nothing (row has no date); 'synced' renders a quiet confirmation pill;
// 'unsynced'/'stale' render an alert-tone pill that IS the retry button.
import { chipStyle } from '../lib/format.js'

export default function SyncChip({ state, onSync, busy = false }) {
  if (state === 'na') return null
  if (state === 'synced') {
    return <span style={chipStyle('#3DB89A')} title="On the shared calendar">Synced</span>
  }
  return (
    <button
      onClick={onSync}
      disabled={busy}
      title="Push this row to the shared Google Calendar"
      style={{ ...chipStyle('var(--color-danger)'), cursor: busy ? 'default' : 'pointer', background: 'transparent', opacity: busy ? 0.5 : 1 }}
    >
      {busy ? 'Syncing…' : 'Not synced · Sync'}
    </button>
  )
}
